<ion-header>
  <ion-toolbar>
    <ion-title>Iniciar Sesión</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-img class="ion-padding-top" src="/assets/images/logo_cmillonario.svg"></ion-img>
  <div class="ion-margin">
    <form (ngSubmit)="login()" [formGroup]="loginForm" novalidate>
      <ion-text color="danger" [hidden]="!error || isLoading">
        <span class="ion-padding" translate>{{ error }}</span>
      </ion-text>
      <ion-list>
        <p translate>login.email</p>
        <ion-item class="input" lines="none">
          <ion-input type="email" formControlName="username" autocomplete="username"></ion-input>
        </ion-item>
        <ion-text
          color="danger"
          [hidden]="loginForm.controls['username'].valid || loginForm.controls['username'].untouched"
        >
          <span class="ion-padding" translate>login.emlrequired</span>
        </ion-text>
        <p class="ion-margin-top" translate>login.password</p>
        <ion-item class="input" lines="none">
          <ion-input
            placeholder="Contraseña"
            type="password"
            formControlName="password"
            autocomplete="current-password"
          >
            <ion-input-password-toggle slot="end"></ion-input-password-toggle>
          </ion-input>
        </ion-item>
        <ion-text
          color="danger"
          [hidden]="loginForm.controls['password'].valid || loginForm.controls['password'].untouched"
        >
          <span class="ion-padding" translate>login.pssrequired</span>
        </ion-text>

        <ion-button
          (click)="openRecovery('recovery')"
          class="ion-margin-top"
          expand="block"
          fill="clear"
          shape="round"
          translate
        >
          login.forgotpss
        </ion-button>

        <ion-button
          class="ion-margin-top"
          type="submit"
          [disabled]="loginForm.invalid || isLoading"
          color="primary"
          expand="block"
          shape="round"
          translate
        >
          login.Login
        </ion-button>

        <ion-item lines="none">
          <ion-label>
            <ion-button
              (click)="openRegisterModal()"
              color="secondary"
              expand="block"
              shape="round"
              [disabled]="!isAllowed"
              translate
            >
              login.create
            </ion-button>
          </ion-label>
        </ion-item>
        <ion-item *ngIf="!isAllowed" lines="none">
          <ion-label color="warning"> <span translate>login.registerMX</span></ion-label>
        </ion-item>
      </ion-list>
    </form>
  </div>
</ion-content>
